var React = require('react');

function FooterHeaderInline (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("linearGradient",{"id":"gradient-tree_footer"},[React.createElement("stop",{"offset":"40%","stopColor":"#ffaa00","key":0}),React.createElement("stop",{"offset":"94%","stopColor":"#ff3270","key":1})])),React.createElement("path",{"fill":"url(#gradient-tree_footer)","fillOpacity":"1","d":"M0,256L80,245.3C160,235,320,213,480,213.3C640,213,800,235,960,256C1120,277,1280,299,1360,309.3L1440,320L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z","key":1})]);
}

FooterHeaderInline.defaultProps = {"viewBox":"0 0 1440 320"};

module.exports = FooterHeaderInline;

FooterHeaderInline.default = FooterHeaderInline;
